var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3109 0.132617L7.87122 3.79934C8.04293 3.97618 8.04293 4.26289 7.87122 4.43971L7.45596 4.86737C7.28454 5.04391 7.00672 5.04425 6.8349 4.86813L3.99999 1.96219L1.1651 4.86813C0.993276 5.04425 0.715456 5.04391 0.544038 4.86737L0.128784 4.43971C-0.0429275 4.26287 -0.0429275 3.97616 0.128784 3.79934L3.68909 0.132617C3.8608 -0.0442064 4.13918 -0.0442064 4.3109 0.132617Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputArrowUp);
export default __webpack_public_path__ + "static/media/input_arrow_up.0607dca76abbb1120750a28793eb4c4b.svg";
export { ForwardRef as ReactComponent };